

import './WhatsAppIcon.css';

function WhatsAppIcon({ phone = '16197611113', message = 'Hello CarbCareUSA, I need help with a carburetor.' }) {
  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${phone}?text=${encodedMessage}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-icon"
      aria-label="Chat on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="whatsapp-icon__svg"
      >
        <path
          fill="currentColor"
          d="M19.11 17.39c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.35-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.48-.84-2.03-.22-.53-.44-.46-.61-.47h-.52c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.34.98 2.64 1.12 2.82.14.18 1.93 2.94 4.68 4.12.66.28 1.18.45 1.59.58.67.21 1.27.18 1.75.11.53-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32z"
        />
        <path
          fill="currentColor"
          d="M16.03 3C8.84 3 3 8.83 3 16c0 2.82.92 5.42 2.48 7.53L3.5 29l5.64-1.86A12.95 12.95 0 0016.03 29C23.22 29 29 23.17 29 16S23.22 3 16.03 3zm0 23.64c-2.22 0-4.29-.65-6.03-1.77l-.43-.27-3.35 1.1 1.1-3.27-.28-.45a10.6 10.6 0 01-1.63-5.71c0-5.87 4.77-10.64 10.64-10.64S26.7 10.4 26.7 16.27 21.9 26.64 16.03 26.64z"
        />
      </svg>
    </a>
  );
}

export default WhatsAppIcon;